export default __webpack_public_path__ + "static/media/MP_Skills_Job-type_02.b502dba7.png";